<div class="h-screen flex items-center justify-center px-4" style="background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 50%, #d1fae5 100%);">
  <div style="width: 100%; max-width: 440px;">
    <div style="background: white; border-radius: 16px; box-shadow: 0 10px 40px rgba(0,0,0,0.08); overflow: hidden;">

      <!-- Logo -->
      <div style="text-align: center; padding: 32px 24px 0;">
        <img src="assets/img/LogoAW2025.png" alt="Aguacate Wallet"
          style="width: 52px; height: 52px; object-fit: contain; margin: 0 auto 12px;">
        <h2 style="font-size: 1.3rem; font-weight: 800; color: #1e5a3f; margin: 0 0 4px;">
          Recupera tu contraseña
        </h2>
        <p style="font-size: 0.85rem; color: #6b7280; margin: 0;">
          Ingresa tu correo electronico registrado
        </p>
      </div>

      <div style="padding: 24px;">
        <ng-container *ngIf="!mailSent; else messageConfirmation">
          <form [formGroup]="mailForm" (ngSubmit)="onSubmit(mailForm)">
            <!-- Email -->
            <div style="margin-bottom: 20px;">
              <label style="display: block; font-size: 0.8rem; font-weight: 600; color: #374151; margin-bottom: 6px;">
                Correo electronico
              </label>
              <div style="display: flex; align-items: center; gap: 10px; border: 1.5px solid #d1d5db; border-radius: 10px; padding: 10px 14px; background: #f9fafb; transition: border-color 0.2s ease;"
                [style.borderColor]="mailForm.get('mail')?.invalid && (mailForm.get('mail')?.dirty || mailForm.get('mail')?.touched) ? '#fca5a5' : '#d1d5db'">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #9ca3af; flex-shrink: 0;">email</mat-icon>
                <input type="email" name="mail" id="mail" formControlName="mail"
                  (keydown.space)="$event.preventDefault()" (paste)="handlePaste($event)"
                  placeholder="correo@mail.com"
                  style="flex: 1; border: none; outline: none; background: transparent; font-size: 0.88rem; color: #111827; padding: 0;">
              </div>
              <div *ngIf="mailForm.get('mail')?.invalid && (mailForm.get('mail')?.dirty || mailForm.get('mail')?.touched)"
                style="margin-top: 4px;">
                <span *ngIf="mailForm.get('mail')?.hasError('required')"
                  style="font-size: 0.75rem; color: #dc2626; font-weight: 500;">
                  Ingresa el correo electronico
                </span>
              </div>
            </div>

            <!-- Error -->
            <div *ngIf="processError" style="margin-bottom: 16px;">
              <div style="display: flex; align-items: center; gap: 8px; justify-content: center; background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px; padding: 10px 16px;">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #dc2626;">error</mat-icon>
                <span style="font-size: 0.82rem; font-weight: 600; color: #991b1b;">{{ errorMessage }}</span>
              </div>
            </div>

            <!-- Submit -->
            <button type="submit"
              [disabled]="mailForm.invalid"
              [style.opacity]="mailForm.invalid ? '0.5' : '1'"
              [style.cursor]="mailForm.invalid ? 'not-allowed' : 'pointer'"
              style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 12px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s ease;"
              onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="if(!this.disabled)this.style.background='#1C593D'">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">send</mat-icon>
              Reiniciar contraseña
            </button>
          </form>

          <div style="text-align: center; margin-top: 16px;">
            <a [routerLink]="['/auth/login']"
              style="font-size: 0.82rem; font-weight: 600; color: #1C593D; text-decoration: none; cursor: pointer;"
              onmouseover="this.style.color='#059669'" onmouseout="this.style.color='#1C593D'">
              Volver al inicio de sesion
            </a>
          </div>
        </ng-container>

        <ng-template #messageConfirmation>
          <div style="text-align: center; margin-bottom: 16px;">
            <div style="display: inline-flex; align-items: center; justify-content: center; width: 56px; height: 56px; background: #f0fdf4; border-radius: 50%; border: 2px solid #bbf7d0;">
              <mat-icon style="font-size: 28px; width: 28px; height: 28px; color: #1C593D;">mark_email_read</mat-icon>
            </div>
          </div>
          <h3 style="font-size: 1.1rem; font-weight: 700; color: #1e5a3f; text-align: center; margin: 0 0 12px;">
            Correo enviado
          </h3>
          <p style="font-size: 0.85rem; color: #6b7280; line-height: 1.6; text-align: center; margin: 0 0 24px;">
            Se ha enviado un correo electronico con las instrucciones para restablecer su
            contraseña. Si no recibe el correo puede solicitarlo nuevamente, si la situacion
            persiste comuniquese con nosotros.
          </p>
          <button type="button" [routerLink]="['/auth/login']"
            style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 12px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">login</mat-icon>
            Ir al inicio de sesion
          </button>
        </ng-template>
      </div>
    </div>
  </div>
</div>
